"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 */
function DownChevron() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "19", height: "12", viewBox: "0 0 19 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M9.44291 6.9061L3.51137 0.608593C2.77638 -0.171743 1.55036 -0.206247 0.772964 0.531526C-0.00442696 1.2693 -0.0387993 2.49997 0.69619 3.2803L8.02198 11.0581C8.78128 11.8642 10.0575 11.8703 10.8244 11.0715L18.2911 3.29368C19.0334 2.5204 19.0107 1.28946 18.2404 0.544297C17.47 -0.200865 16.2437 -0.17807 15.5014 0.595212L9.44291 6.9061Z", fill: "white" }) }));
}
exports.default = DownChevron;
//# sourceMappingURL=DownChevron.js.map